import { css } from "styled-components";

export interface IMediaBreakpoints {
    phone: number;
    tablet: number;
    desktop: number;
    bigDesktop: number;
    hamburgerMenu: number;
}

const breakpoints: IMediaBreakpoints = {
    bigDesktop: 1800,
    desktop: 1200,
    hamburgerMenu: 1265,
    phone: 600,
    tablet: 900,
};

export interface IMedia {
    phone: any;
    tablet: any;
    desktop: any;
    bigDesktop: any;
    hamburgerMenu: any;
}

const mediaQuery = (...query) => (...rules) => css`
    @media ${css(...query)} {
        ${css(...rules)}
    }
`;

const media: IMedia = {
    bigDesktop: mediaQuery`(min-width: ${breakpoints.bigDesktop / 16}em)`,
    desktop: mediaQuery`(min-width: ${breakpoints.desktop / 16}em)`,
    hamburgerMenu: mediaQuery`(min-width: ${breakpoints.hamburgerMenu / 16}em)`,
    phone: mediaQuery`(min-width: ${breakpoints.phone / 16}em)`,
    tablet: mediaQuery`(min-width: ${breakpoints.tablet / 16}em)`,
};

export { media };
